import cache from "memory-cache";

// MS * SECONDS * MINUTES * HOURS
const DEFAULT_TTL = 1000 * 60 * 60 * 6; // 6 hours

export const put = (key: string, value: any, ttl = DEFAULT_TTL) =>
  cache.put(key, value, ttl);

export const get = (key: string) => cache.get(key);
